import Hero from "../components/Hero";
import CardGrid from "../components/CardGrid";
import { dayTours } from "../data/tours";
import { packages } from "../data/packages";
import "./Home.css";

export default function Home() {
  // Merge all package categories into one array
  const allPackages = Object.values(packages).flat();

  return (
    <>
      {/* Hero section with YouTube video background */}
      <Hero
        title="Muhammed Zanzibar Tours & Beach Safaris"
        subtitle="Explore Zanzibar and Tanzania with local experts"
        ctaText="View Day Tours"
        ctaHref="/day-tours"
        youtube="DZnw2TeLuEU" 
      />

      {/* Welcome / About Mohammed */}
<section
  className="section welcome"
  style={{
    backgroundImage: "url('/images/sand.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="welcome-grid">
    {/* Left: Mohammed image */}
    <div className="welcome-image">
      <img
        src="/images/tourists.jpg"
        alt="Mohammed - Zanzibar Tours & Safaris"
      />
    </div>

    {/* Right: Description */}
    <div className="welcome-content">
      <h2>Welcome to Muhammed Zanzibar Tours & Safaris</h2>

      <p className="welcome-quote">
        “Zanzibar is not just a destination, it is a feeling — and I am
        here to help you experience it the local way.”
      </p>

      <p>
        My name is <strong>Muhammed</strong>, a local tour guide
        and safari specialist with years of experience organizing
        unforgettable journeys across Zanzibar and mainland Tanzania.
        From pristine white-sand beaches and rich Swahili culture to
        world-famous wildlife safaris and Mount Kilimanjaro adventures,
        every trip is crafted with care, safety, and authenticity.
      </p>

      <p>
        I personally work with trusted drivers, professional guides, and
        quality accommodations to ensure your holiday is smooth,
        memorable, and truly unique. Whether you are visiting for
        relaxation, adventure, honeymoon, or family travel, my team and I
        are ready to customize the perfect experience for you.
      </p>

      <p>
        Karibu sana Zanzibar — welcome to Tanzania. Let us turn your
        travel dreams into unforgettable memories.
      </p>
      <p><strong>ZANZIBAR - HAKUNA MATATA</strong></p>
    </div>
  </div>
</section>

      {/* Popular Day Tours */}
      <section className="section">
        <h2>Popular Day Tours</h2>
        <CardGrid items={dayTours.slice(0, 6)} />
      </section>

      {/* Featured Packages */}
      <section className="section">
        <h2>Featured Packages</h2>
        <CardGrid
          items={allPackages.slice(0, 3).map((p) => ({
            ...p,
            cta: { label: "Customize", href: "/contact" }
          }))}
        />
      </section>

      {/* Why Choose Us */}
      <section className="section small">
        <h2>Why Choose Us</h2>
        <div className="features">
          <div className="feature">
            <h3>Local Knowledge</h3>
            <p>
              Born and raised in Zanzibar, we offer authentic experiences guided
              by deep local knowledge.
            </p>
          </div>
          <div className="feature">
            <h3>Flexible Itineraries</h3>
            <p>
              Every tour and safari can be customized to match your interests,
              schedule, and budget.
            </p>
          </div>
          <div className="feature">
            <h3>Trusted Service</h3>
            <p>
              Reliable transfers, comfortable vehicles, professional guides,
              and a safety-first approach.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
